import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { ApiService } from '../../../services/api.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '../../reusable/breadcrumb/breadcrumb.component';
import { MarkdownEditorComponent } from '../../reusable/markdown-editor/markdown-editor.component';
import { convertMarkdownToHtml, hasHtml } from '../../reusable/markdown-editor/markdown-editor.utils';

@Component({
  selector: 'app-create-global-tag',
  imports: [ModalModule, CommonModule, FormsModule, ReactiveFormsModule, ToastrModule, BreadcrumbComponent, MarkdownEditorComponent],
  templateUrl: './create-global-tag.component.html',
  styleUrl: './create-global-tag.component.scss'
})
export class CreateGlobalTagComponent {
  @Output() modalClosed = new EventEmitter<void>();
  globalTagData: any;
  parentPage: any
  globalTagForm!: FormGroup;
  breadcrumbItems: Array<{ label: string }> = [];

  constructor(
    public modalRef: BsModalRef,
    private fb: FormBuilder,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.globalTagForm = this.fb.group({
      tag_name: [null, [Validators.required, Validators.maxLength(100)]],
      description: [null, [Validators.required]],
      deleted: [false]
    });

    if (this.globalTagData) {
      this.globalTagForm.patchValue(this.globalTagData);
    }
    this.breadcrumbItems = [
      { label: this.parentPage },
      { label: 'Create Global Tags' }
    ];
  }

  onSubmit() {
    this.submitForm(false);
  }

  saveAndCreateAnother() {
    this.submitForm(true);
  }

  private submitForm(createAnother: boolean) {
    if (this.globalTagForm.valid) {
      const formValue = this.globalTagForm.getRawValue();
      const payload = {
        ...formValue,
        description: hasHtml(formValue.description)
          ? formValue.description
          : convertMarkdownToHtml(formValue.description),
      };

      if (this.globalTagData) {
        this.apiService.patch(`globalTag/update/${this.globalTagData.id}`, payload).subscribe({
          next: (res: any) => {
            this.toastr.success('Global tag updated successfully!', 'Success');
            this.closeModal();
            this.globalTagForm.patchValue(res);
          },
          error: (err) => {
            console.error('Error updating global tag:', err);
            this.toastr.error(err.error?.message || 'Failed to update tag.', 'Error');
          }
        });
      } else {
        this.apiService.post('globalTag', payload).subscribe({
          next: (res: any) => {
            this.toastr.success('Global tag created successfully!', 'Success');
            if (createAnother) {
              this.globalTagForm.reset({
                tag_name: null,
                description: null,
                deleted: false,
              });
              this.globalTagForm.markAsPristine();
              this.globalTagForm.markAsUntouched();
              return;
            }

            this.closeModal();
          },
          error: (err) => {
            console.error('Error creating global tag:', err);
            this.toastr.error(err.error?.message || 'Failed to create global tag.', 'Error');
          }
        });
      }
    } else {
      this.globalTagForm.markAllAsTouched();
    }
  }

  closeModal() {
    this.modalClosed.emit();
    this.modalRef.hide();
    this.cdr.detectChanges();
  }
}
